import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#2D2A5D] text-white pt-12 pb-6">
      <div className="container mx-auto md:px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Premier bloc - EDMF */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold mb-4">EDMF</h3>
            <p className="mb-4">
              Ets Doudou MENDY & FILS - Votre partenaire de confiance pour tous vos projets de construction et rénovation
              depuis plus de 25 ans.
            </p>
            <div className="flex justify-center md:justify-start space-x-4">
              <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
          
          {/* Deuxième bloc - Services */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Peinture
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Maçonnerie
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Électricité
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Étanchéité
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Charpente
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Entretien Bâtiment
                </a>
              </li>
            </ul>
          </div>
          
          {/* Troisième bloc - Pages */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-4">Pages</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Accueil
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  Réalisations
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition-colors cursor-pointer">
                  À propos
                </a>
              </li>
            </ul>
          </div>
          
          {/* Quatrième bloc - Contact */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex justify-center md:justify-start items-start">
                <i className="fas fa-map-marker-alt mt-1 mr-3"></i>
                <span>K.M Cité Gandel Cissé </span>
              </li>
              <li className="flex justify-center md:justify-start items-start">
                <i className="fas fa-phone-alt mt-1 mr-3"></i>
                <span>78 995 43 70  -  77 790 14 74  -  77 404 23 31</span>
              </li>
              <li className="flex justify-center md:justify-start items-start">
                <i className="fas fa-envelope mt-1 mr-3"></i>
                <span>edmf09@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright et liens légaux */}
        <div className="pt-8 border-t border-gray-700 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} EDMF - Ets Doudou MENDY & FILS. Tous droits réservés.</p>
          <div className="flex justify-center space-x-4 mt-4">
            <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
              Mentions légales
            </a>
            <span className="text-gray-500">|</span>
            <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
              Politique de confidentialité
            </a>
          </div>
          {/* <div className="flex justify-center space-x-4 mt-4">
            <i className="fab fa-cc-visa text-2xl"></i>
            <i className="fab fa-cc-mastercard text-2xl"></i>
            <i className="fab fa-cc-paypal text-2xl"></i>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
